import styled from 'styled-components';
import { StockCardStyled } from '../StockCardStyled';

export const StockCardStyledOV = styled(StockCardStyled)`
    background: ${({ theme }) => theme.colors.pureWhite};
`;
